module.exports = __webpack_public_path__ + "static/media/html.28733123.jpg";